import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import { MatDialog } from '@angular/material/dialog';
import { catchError, Observable, throwError } from 'rxjs';
import { showErrorDialog } from '../../shared/utils';
import {
  AuditTrailTransactionNotesDistributionItem,
  TransactionNotesFilesPendingDistributionCountResponse
} from './audit-trail-transaction-notes-distribution-item.model';

@Injectable({
  providedIn: 'root'
})
export class AuditTrailTransactionNotesDistributionService {
  private apiEndpoint = `${environment.apiEndpoint}/api/audit-trail/transaction-notes-distribution`;

  constructor(
    private http: HttpClient,
    private logger: NGXLogger,
    private errorDialog: MatDialog
  ) {}

  public triggerTransactionNotesDistribution$(): Observable<{ message: string }> {
    return this.http.post<{ message: string }>('api/triggerTransactionNotesDistribution', {}).pipe(
      catchError((error: any) => {
        this.logger.error(error);
        showErrorDialog(this.errorDialog, error);
        return throwError(() => error);
      })
    );
  }

  public countTransactionNotesFilesPendingDistribution$(): Observable<TransactionNotesFilesPendingDistributionCountResponse> {
    return this.http
      .get<TransactionNotesFilesPendingDistributionCountResponse>('api/countTransactionNotesFilesPendingDistribution')
      .pipe(
        catchError((error: any) => {
          this.logger.error(error);
          showErrorDialog(this.errorDialog, error);
          return throwError(() => error);
        })
      );
  }

  public getAuditTrailTransactionNotesDistributionItems$(
    startDate: Date,
    endDate: Date,
    transactionId: number | null
  ): Observable<AuditTrailTransactionNotesDistributionItem[]> {
    return this.http
      .get<AuditTrailTransactionNotesDistributionItem[]>(`${this.apiEndpoint}`, {
        params: this.computeQueryParams(startDate, endDate, transactionId)
      })
      .pipe(
        catchError((error: any) => {
          this.logger.error(error);
          showErrorDialog(this.errorDialog, error);
          return throwError(() => error);
        })
      );
  }

  public sendNotificationEmailForTransactionNoteDistributionItem$(
    auditTrailTransactionNotesDistributionItemIds: number[]
  ): Observable<AuditTrailTransactionNotesDistributionItem[]> {
    return this.http
      .post<
        AuditTrailTransactionNotesDistributionItem[]
      >(`${this.apiEndpoint}/send-new-transaction-notes-notification-emails`, { auditTrailTransactionNotesDistributionItemIds })
      .pipe(
        catchError((error: any) => {
          this.logger.error(error);
          showErrorDialog(this.errorDialog, error);
          return throwError(() => error);
        })
      );
  }

  private computeQueryParams(startDate: Date, endDate: Date, transactionId: number | null) {
    const params: { [param: string]: string } = {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString()
    };

    if (transactionId) {
      params['transactionId'] = transactionId.toString();
    }

    return params;
  }
}
